var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padded"},[_c('h2',{staticClass:"text-warning",staticStyle:{"padding-top":"5vh"}},[_vm._v("Coming Soon")])])}]

export { render, staticRenderFns }